import { Tuple } from "../components/Shared/Interfaces"

export const UNDEFINED_CODE = "-99"
export const ALL_CODE = "0"
export const ALL_NAME = "All"
export const EMPTY_STATE = []

export const defaultTuple: Tuple = {
	code: ALL_CODE,
	name: ALL_NAME,
}

export const getParameterValues = (tuples: Array<Tuple>): string => {
	if (tuples.find(({ code }) => code === ALL_CODE)) {
		return ALL_CODE
	}
	return tuples.map(({ code }) => code).join()
}

export const concatValues = (values: Array<Tuple>) =>
	values?.map((value: Tuple) => value.code).join()

export const concatNames = (values: Array<Tuple>) =>
	values?.map((value: Tuple) => value.name).join()
